import { GHL_EVENT_SCHEDULED, GHL_URL_REGEX } from './constants';

import type { FormValues } from '$lib/types/Form';

/**
 * GoHighLevel (GHL) integration module
 * Provides utilities for validating URLs, building iframe URLs with UTM parameters,
 * and detecting booking confirmation events
 */
export const ghl = {
    validateUrl: (url: string): boolean => {
        return GHL_URL_REGEX.test(url);
    },

    /**
     * Builds the iframe URL with UTM parameters
     * GHL does not save the utms as a data fields, but they are still visible in documentUrl field in appointment details
     */
    buildIframeUrl: (baseUrl: string, trackingProperties: FormValues): string => {
        const url = new URL(baseUrl);
        const { utm_campaign, utm_source, utm_medium, utm_content, utm_term } = trackingProperties;

        if (utm_source) {
            url.searchParams.set('utm_source', utm_source as string);
        }

        if (utm_medium) {
            url.searchParams.set('utm_medium', utm_medium as string);
        }

        if (utm_campaign) {
            url.searchParams.set('utm_campaign', utm_campaign as string);
        }

        if (utm_content) {
            url.searchParams.set('utm_content', utm_content as string);
        }

        if (utm_term) {
            url.searchParams.set('utm_term', utm_term as string);
        }

        return url.toString();
    },

    isBookingSuccessful: (data: unknown): boolean => {
        if (Array.isArray(data) && data.length > 0) {
            const [eventType] = data;
            return eventType === GHL_EVENT_SCHEDULED;
        }

        return false;
    },
};
